import { PropsWithChildren } from 'react';
import csMessages from '../../shared/locales/cs.json';
import enMessages from '../../shared/locales/en.json';
import deMessages from '../../shared/locales/de.json';
import ukMessages from '../../shared/locales/uk.json';
import skMessages from '../../shared/locales/sk.json';
import { IntlProvider } from 'react-intl';
import { usePersistentFilters } from '@shared/store';

const messages: { [key: string]: Record<string, string> } = {
  cs: csMessages,
  en: enMessages,
  uk: ukMessages,
  de: deMessages,
  sk: skMessages,
};

type IntlComponentProps = PropsWithChildren & {
  language?: string;
};

const IntlComponent = (props: IntlComponentProps) => {
  const [filter] = props.language ? [{ language: props.language }] : usePersistentFilters();
  const appMessages = messages[filter.language] || messages.cs;

  return (
    <IntlProvider locale={filter.language} messages={appMessages}>
      {props.children}
    </IntlProvider>
  );
};

export default IntlComponent;

export const getLanguageFromStorage = (): string => {
  try {
    const stored = localStorage.getItem('persistentFilters');

    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed.language) return parsed.language;
    }
  } catch (e: unknown) {
    if (e instanceof Error) {
      console.error('Error getting language from storage:', e.message);
    } else {
      console.error('Error getting language from storage:', e);
    }
  }

  // Auto-detect from browser preferences
  const lang = navigator.language?.toLowerCase().split('-')[0];
  const supported = ['cs', 'en', 'de', 'uk', 'sk'];
  return supported.includes(lang) ? lang : 'cs';
};
